import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { BaseURL } from "../components/Common";
import { Palette } from "../AppConfig";

// Material UI
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Icon from "@material-ui/core/Icon";
import EventAvailable from "@material-ui/icons/EventAvailable";

import { changeMainPage, toggleAPP } from "../redux_store/appState";
import { Badge } from "@material-ui/core";
import { useWindowDimensions } from "../helper/Helper";

// const drawerWidth = 260;
// const toolDrawerWidth = 160;

const useStyles = makeStyles({
    root: {},
    drawer: {
        width: "80px",
        flexShrink: 0,
        whiteSpace: "nowrap",
        overflowX: "hidden",
        zIndex: 100,
        paddingTop: "120px",
        display: "inline",
        backgroundColor: "#F4F4F4",
        // borderRight: '1px solid rgba(0, 0, 0, 0.2)',
    },
    drawerList: {
        display: "flex",
        flexDirection: "column",
    },
    selected: {
        background: "#002D6222",
        borderRight: "4px solid " + Palette.FieldersBlue,
        // color: "white !important",
        "&:hover": {
            backgroundColor: "#6B879988",
            // color: "white !important",
        },
    },
    grayedOut: {
        opacity: "0.5",
    },
    selectedContent: {
        color: "white",
    },
    imageIcon: {
        height: "100%",
    },
    iconRoot: {
        textAlign: "center",
        width: "36px",
        height: "36px",
    },
    iconText: {
        fontSize: "13px",
        textAlign: "center",
        marginTop: "8px",
    },
});

const StyledListItem = withStyles({
    root: {
        //   paddingLeft: "0px",
        color: "rgba(0, 0, 0, 0.54)",
    },
})(ListItem);

const StyledListItemIcon = withStyles({
    root: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "48px",
        minWidth: "48px",
        color: Palette.FieldersBlue,
        marginTop: "4px",
    },
})(ListItemIcon);

export default function Main_ToolBar() {
    const classes = useStyles();
    const dispatch = useDispatch();
    const app = useSelector((state) => state.app);
    const user = useSelector((state) => state.app.user);
    const main_page = useSelector((state) => state.app.MAIN_PAGE);
    const number_orders_to_process = useSelector((state) => state.app.number_orders_to_process);
    const { height } = useWindowDimensions();
    const [debugShow, setDebugShow] = React.useState(true);

    const handleHelp = () => {
        if (main_page?.page !== "Orders") dispatch(toggleAPP("help_open", !app?.help_open));
    };

    return (
        <Drawer variant="permanent" className={classes.drawer} classes={{ paper: classes.drawer }} open={false}>
            <List style={{ height: height - 140 }} className={classes.drawerList}>
                {/* <Tooltip title="Manage Jobs"> */}
                <StyledListItem
                    button
                    key={"Manage Jobs"}
                    className={main_page.page === "Recall" ? classes.selected : ""}
                    onClick={() => {
                        dispatch(changeMainPage("Recall"));
                    }}
                >
                    <StyledListItemIcon>
                        <Icon classes={{ root: classes.iconRoot }}>
                            {window.FIELDERS ? (
                                <img
                                    alt=""
                                    className={classes.imageIcon}
                                    src={BaseURL(
                                        "/images/jobs" + (main_page.page === "Recall" ? "-active" : "") + ".svg"
                                    )}
                                />
                            ) : (
                                <img
                                    alt=""
                                    width="36"
                                    className={classes.imageIcon}
                                    src={BaseURL("/images/jobsLysaght.svg")}
                                />
                            )}
                        </Icon>
                        <div className={classes.iconText}>Jobs</div>
                    </StyledListItemIcon>
                </StyledListItem>

                {user?.Role && user?.Role >= 90 && user?.Role !== 92 && (
                    <StyledListItem
                        button
                        key={"Orders"}
                        className={main_page.page === "Orders" ? classes.selected : ""}
                        onClick={() => {
                            dispatch(changeMainPage("Orders"));
                        }}
                    >
                        <Badge badgeContent={number_orders_to_process} color="secondary">
                            <StyledListItemIcon>
                                {/* <Icon classes={{ root: classes.iconRoot }}></Icon> */}
                                {window.FIELDERS ? (
                                    <EventAvailable classes={{ root: classes.iconRoot }} />
                                ) : (
                                    <img
                                        alt=""
                                        width="36"
                                        className={classes.imageIcon}
                                        src={BaseURL("/images/ordersLysaght.svg")}
                                    />
                                )}
                                <div className={classes.iconText}>Orders</div>
                            </StyledListItemIcon>
                        </Badge>
                    </StyledListItem>
                )}


                {/* <StyledListItem
                    button
                    key={"News"}
                    className={main_page.page === "News" ? classes.selected : ""}
                    onClick={() => {
                        dispatch(changeMainPage("News"));
                    }}
                >
                    <StyledListItemIcon>
                        <Icon classes={{ root: classes.iconRoot }}>
                            {window.FIELDERS ? (
                                <img
                                    className={classes.imageIcon}
                                    src={
                                        main_page.page === "News"
                                            ? BaseURL("/images/news-active.svg")
                                            : BaseURL("/images/news.svg")
                                    }
                                />
                            ) : (
                                <img
                                    width="36"
                                    className={classes.imageIcon}
                                    src={BaseURL("/images/jobsLysaght.svg")}
                                />
                            )}
                        </Icon>
                        <div className={classes.iconText}>News</div>
                    </StyledListItemIcon>
                </StyledListItem> */}

                {window.brand === "Lysaght" && (
                    <div style={{ flex: 1, display: "flex", alignItems: "end" }}>
                        <StyledListItem
                            button
                            key={"Help"}
                            className={`${main_page.page === "Help" ? classes.selected : ""} ${
                                main_page.page === "Orders" && classes.grayedOut
                            }`}
                            onClick={handleHelp}
                        >
                            <StyledListItemIcon>
                                {/* <PublishIcon  style={{width:"36px", height: "36px"}} /> */}
                                <Icon classes={{ root: classes.iconRoot }}>
                                    <img
                                        alt=""
                                        className={classes.imageIcon}
                                        width={window.FIEDLERS ? "" : "36"}
                                        src={BaseURL(window.FIEDLERS ? "/images/help.svg" : "/images/helpLysaght.svg")}
                                    />
                                </Icon>
                                <div className={classes.iconText}>Help</div>
                            </StyledListItemIcon>
                        </StyledListItem>
                    </div>
                )}
                {/* </Tooltip> */}
            </List>
        </Drawer>
    );
}
